import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {

  connect() {
    this.initOneItemSwiper();
    this.setupAccessibility();
  }

  setupAccessibility() {
    // Add keyboard event listeners for accessibility
    this.element.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.oneItemSwiper.slidePrev();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        this.oneItemSwiper.slideNext();
        e.preventDefault();
      }
    });
  }

  initOneItemSwiper() {
    const element = this.element;

    const indicators = this.element.querySelector('.indicators');
    const nextBtn = this.element.querySelector('.next');
    const prevBtn = this.element.querySelector('.prev');

    this.oneItemSwiper = new Swiper(this.element, {
      modules: [Navigation, Pagination, Keyboard, A11y],
      autoHeight: true,
      loop: true,
      pagination: {
        el: indicators,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} indicator-dot"></span>`;
        }
      },
      keyboard: {
        enabled: true,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        notificationClass: 'sr-only'
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        slideChange: function() {
          const activeIndex = this.realIndex; 
          const colors = ['#E7ECEE', '#E9DECA', '#E2D6E5', '#D4D8E4'];
          const parentDiv = element;
          parentDiv.style.backgroundColor = colors[activeIndex % colors.length];
          
          // Update accessibility status for screen readers
          const totalSlides = this.slides && this.slides.length ? this.slides.length - (this.loopedSlides ? this.loopedSlides * 2 : 0) : 0;
          const currentSlide = activeIndex + 1;
          const statusElement = element.querySelector('#carousel-status');
          if (statusElement) {
            statusElement.textContent = `Showing slide ${currentSlide} of ${totalSlides}`;
          }

          // Store a reference to 'this' (the Swiper instance) to use inside setTimeout
          const swiperInstance = this;
          
          // Focus on the current slide for screen readers
          setTimeout(() => {
            // Use swiperInstance instead of 'this' to ensure we have the correct reference
            const activeSlide = swiperInstance.slides && swiperInstance.activeIndex !== undefined ? 
                               swiperInstance.slides[swiperInstance.activeIndex] : null;
            if (activeSlide && typeof activeSlide.hasAttribute === 'function') {
              // Make sure the slide is focusable
              if (!activeSlide.hasAttribute('tabindex')) {
                activeSlide.setAttribute('tabindex', '0');
              }
              
              // Only focus if the user is using keyboard navigation
              if (document.activeElement && 
                  (document.activeElement.classList.contains('prev') || 
                   document.activeElement.classList.contains('next') ||
                   document.activeElement.classList.contains('indicator-dot')) &&
                  typeof activeSlide.focus === 'function') {
                activeSlide.focus();
              }
            }
          }, 100);
        }
      },
    });
  }
}
